export const REFERRAL_PARTNERS = {
  C9H2NV3K: {
    name: 'Network International',
    logoPath: '/network-international-logo.png',
  },
};

export const getReferralPartner = (code) => {
  if (!code) {
    return null;
  }

  return REFERRAL_PARTNERS[code.toUpperCase()] ?? null;
};
